module.exports = __webpack_public_path__ + "img/debatePresi20192.bbe83285.jpg";